import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { videos } from 'src/constants/videos'
import styled from 'styled-components'
import { promoCodes } from 'src/constants/promoCodes'
import { useCtaText } from 'src/modules/hooks/useCtaText'
import { usPlanData } from 'src/constants/planData/usPlanData'

export default (props) => {
  // const dispatch = useDispatch()

  // const params = {
  //   irad: '366904',
  //   irmp: '365718',
  // }

  // useEffect(() => {
  //   dispatch(updateParams(params))
  // }, [])
  const ctaCopy = useCtaText({ lang: 'en', market: 'us', disableFreeTrial: false })

  const plans = [
    {
      ...usPlanData.pro_monthly,
      bannerImage: null,
      backgroundColor: null,
      offerCode: promoCodes.charter_pro_plan,
      savingsNote: 'Save $22',
      price: 73.99,
      discountedPrice: 51.79,
      banner: 'Exclusive offer: 30% off for 2 months!',
      networkLogos: null,
      footnote: null,
      listItems: (data) => [
        { available: true, text: `${data.channels}+ live TV channels` },
        {
          available: true,
          text: <span>Includes MLB and FanDuel Sports Network</span>,
        },
        { available: true, text: 'Unlimited Cloud DVR' },
        { available: true, text: 'Watch on up to 10 screens at once' },
        { available: true, text: 'ESPN Unlimited included' },
      ],
    },
    {
      ...usPlanData.elite_monthly,
      title: 'Fubo Elite',
      bannerImage: null,
      backgroundColor: null,
      offerCode: promoCodes.charter_elite_plan,
      savingsNote: 'Save $25',
      price: 83.99,
      discountedPrice: 58.79,
      banner: 'Exclusive offer: 30% off for 2 months!',
      networkLogos: null,
      footnote: null,

      listItems: (data) => [
        { available: true, text: `${data.channels}+ live TV channels` },
        {
          available: true,
          text: <span>Includes MLB and FanDuel Sports Network</span>,
        },
        { available: true, text: 'Unlimited Cloud DVR' },
        { available: true, text: 'Watch on up to 10 screens at once' },
        { available: true, text: '4K included' },
        { available: true, text: 'ESPN Unlimited included' },
      ],
    },
  ]

  return (
    <StyledContainer>
      <USTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        offerCode={promoCodes.charter_elite_plan}
        offerBanner={{
          title: [
            'Xfinity discount applied!',
            'Xfinity customers get 30% off your first two months',
          ],
        }}
        video={videos.mlbtv.videoUrl}
        title="Watch FanDuel Sports Network"
        subtitle="Stream live games and local team coverage. Regional restrictions apply."
        logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-xfinity.png?ch=width&auto=format,compress"
        networkSubtitle={'Cancel online anytime.'}
        removeCable={true}
        networkSet="sports"
        customNetworks={['fanduelsports']}
        showRSN={true}
        ctaText={ctaCopy}
        hasPlanCards={true}
        plans={plans}
        hideNetworkSection={true}
        hasCharterPlanCards={true}
        planCardsFootnote={
          '*Reg. prices in effect after 2-mo promotional period ends. Additional taxes and fees may apply. Prices subject to change. Regional restrictions apply.'
        }
        noIndex={true}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  .planCard__price {
  }
`
